import React, { useEffect, useState } from 'react'

import Loading from '@/shared/components/common/Loading'
import { TYPE_FAQLIST } from '@/shared/constant/cmdtype'
import { COLOR } from '@/shared/constant/color'
import { useFaqListQueryData } from '@/shared/hooks/reactquery'
import useWindowDimensions from '@/shared/hooks/useGetWindowSize'
import { useMoreButton } from '@/shared/hooks/useMoreButton'
import { CustomBtn } from '@/styles/common/CommonForm/buttonform'
import {
  FaqArrow,
  FaqList,
  FaqListItemA,
  FaqListItemQ,
  FaqTab,
  FaqTabItem,
  FaqWrap,
} from '@/styles/views/Support/Faq'

const FaqPage = () => {
  const [ContentType, setContentType] = useState(1001)
  const [ContentValue, setContentValue] = useState(0)
  const [more, onChangeMore, setMore] = useMoreButton(0)
  const { width } = useWindowDimensions()

  const tabList = [
    { idx: 0, text: '가입 및 해지', type: 1001 },
    { idx: 1, text: '이용문의', type: 1002 },
    { idx: 2, text: '기능문의', type: 1003 },
    { idx: 3, text: '기타', type: 1004 },
  ]

  const { isLoading, data: FaqListdata } = useFaqListQueryData(TYPE_FAQLIST, ContentType, more)

  const AnswerOpen = (option: any) => {
    setContentValue(option)
    if (option === ContentValue) {
      setContentValue(0)
    }
  }
  useEffect(() => {
    setMore(0)
  }, [ContentType, setMore])

  return (
    <FaqWrap>
      {isLoading && <Loading />}
      <FaqTab>
        {tabList.map((option: { idx: number; text: string; type: number }) => (
          <FaqTabItem
            color={option.type === ContentType ? COLOR.black : COLOR.blueGray2}
            key={option.idx}
            onClick={() => setContentType(option.type)}
          >
            {option.text}
          </FaqTabItem>
        ))}
      </FaqTab>
      <FaqList>
        {FaqListdata?.Body?.map((option: any) => (
          <React.Fragment key={option.Idx}>
            <FaqListItemQ key={option.Idx} onClick={() => AnswerOpen(option?.Idx)}>
              <span>{option.Title}</span>
              <FaqArrow active={option.Idx === ContentValue} />
            </FaqListItemQ>
            {option.Idx === ContentValue && <FaqListItemA>{option.Contents}</FaqListItemA>}
          </React.Fragment>
        ))}
      </FaqList>
      {FaqListdata?.Body?.length >= (more + 1) * 5 && (
        <CustomBtn
          className={width > 1200 ? 'health_btn_pc' : 'health_btn_mo'}
          color={COLOR.point1}
          bgColor={COLOR.white}
          borderColor={COLOR.point1}
          borderRadius={'40px'}
          marginTop={width > 1200 ? '68px' : '43px'}
          width={width > 1200 ? '356px' : '328px'}
          height={width > 1200 ? '56px' : '44px'}
          fontSize={width > 1200 ? '18px' : '14px'}
          fontFamily={width > 1200 ? 'NanumSquareNeoHeavy, sans-serif' : 'NotoSansBold, sans-serif'}
          onClick={onChangeMore}
        >
          <span>더보기</span>
        </CustomBtn>
      )}
    </FaqWrap>
  )
}
export default FaqPage
